export default __webpack_public_path__ + "static/media/cupom@3x.c9e6938c.png";